<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: 'Puzzle-Root',
};
</script>
